import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import config from "../config";

const Shopnow = () => {
    const { id } = useParams(); // this is the actual product id
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await fetch(`${config.baseURL}/productsfront/20`); // category data
        if (!res.ok) throw new Error("Failed to fetch product detail");

        const data = await res.json();

        // Filter the product by id
        const matched = data.find((item) => item.id.toString() === id.toString());

        if (!matched) {
          alert("Product not found");
          return;
        }

        setProduct(matched);
      } catch (error) {
        console.error(error);
        alert("Error fetching product");
      }
    };

    fetchProduct();
  }, [id]);

  if (!product) return <p>Loading...</p>;
  
  return (
    <div>
      <div className="max-w-65rem py-[2rem]">
        <div className="text-center">
          <section>
            <div className="">
              <div className="relative">
                <div className="bg-white px-7">
                  <div className="text-left border-b">
                    <h2 className="text-2xl font-bold text-left">
                      <span>Part No.</span>Checkout
                    </h2>
                    <h2 className="text-2xl font-bold text-left">
                      Internal Circlip DIN 472 Metric
                    </h2>
                    <ol className="flex items-center space-x-1 mb-5">
                      <li className="after:content-['/'] after:mx-2 last:after:content-none">
                        <a href="">
                          <span>Home</span>
                        </a>
                      </li>
                      <li className="after:content-['/'] after:mx-2 last:after:content-none">
                        <a href="">
                          <span>About Us</span>
                        </a>
                      </li>
                      <li className="after:content-['/'] after:mx-2 last:after:content-none">
                        <a href="">
                          <span>Contact Us</span>
                        </a>
                      </li>
                      <li className="after:content-['/'] after:mx-2 last:after:content-none">
                        <a href="">
                          <span>Our Product</span>
                        </a>
                      </li>
                    </ol>
                  </div>
                  <div className="flex flex-wrap gap-10 lg:gap-6 justify-evenly">
                    <div className="w-full bg-white">
                      <div className="container mx-auto p-4">
                        <p className="text-start pb-5">
                          Additional information
                        </p>
                        <div className="p-4 bg-[#9eaaaa1a]">
                          <table className="w-full table-auto">
                            <tbody>
                              <tr className="border-b border-gray-200">
                                <th className="w-1/2 px-4 py-2 text-left text-[#85868c]">
                                  Bore
                                </th>
                                <td className="w-1/2 px-4 py-2 text-left text-[#666]">
                                  {product.bore}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Thick
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.thick}
                                </td>
                                </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Thickness Tolerance
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.thickness_tolerance}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Free Diameter
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.free_diameter}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Free Diameter Tolerance
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  not definde
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Clearance on Bore
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.clearance_onboare}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Beam
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.beam}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Lug
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.lug}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Hole Diameter
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.hole_diamter}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Ring Load Carrying Capacity
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.ring_load_carrying_capacity}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Groove Diameter
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.groove_diameter}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Groove Diameter Tolerance
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.groove_tolerance}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Groove Width
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.groove_width}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Edge Margin
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.edge_margin}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Groove Load Capacity
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  {product.groove_load_capacity}
                                </td>
                              </tr>
                              <tr className="border-b border-gray-200">
                                <th className="px-4 py-2 text-left text-[#85868c]">
                                  Material
                                </th>
                                <td className="px-4 py-2 text-left text-[#666]">
                                  not defined 
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div>
                        <p className="text-left mt-4 text-[1.234rem] text-[#666]">Learn more about <Link to="/products2/20" className="text-[#EF3F33] underline underline-offset-3 hover:no-underline">Internal Circlip DIN 472 Metric</Link></p>
                        <div className="mt-5"><span className="bg-[#EF3F33] text-white text-[2rem] font-bold p-3 rounded-md">Please call for latest prices</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Shopnow;
